var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongPaixu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.146 6.146a.5.5 0 01-.353.854H5.207a.5.5 0 01-.353-.854l2.792-2.792a.5.5 0 01.708 0l2.792 2.792zM11.146 10.854a.5.5 0 00-.353-.854H5.207a.5.5 0 00-.353.854l2.792 2.792a.5.5 0 00.708 0l2.792-2.792z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_paixu.805832fd.svg";
export { SvgTongyongPaixu as ReactComponent };